var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.94592 9.19672L9.84109 10.1212L7.1542 11.258L4.44498 12.4045L4.94213 9.21347C5.14602 7.90634 5.89455 7.79602 7.16677 7.38684","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M8.94592 9.19672L14.7303 15.1682L24.3941 1.86505L8.94592 9.19672Z","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M7.16817 7.38684L7.16677 7.38544L24.3941 1.86505L1.41455 1.46704L7.16817 7.38684Z","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Email.defaultProps = {"viewBox":"0 0 26 16"};

module.exports = Email;

Email.default = Email;
